import React from 'react';
import './Footer.css';
import logo from '../assets/logo_hpfs.png';
import './universal.css';

export default function Footer() {
  return (
    <footer className="brand-footer">
      <div className="brand-footer-top" />
      <div className="container">
        <div className="brand-footer-content">
          <div className="brand-col about">
            <div className="brand-footer-logo-wrapper">
              <img src={logo} alt="logo" className="brand-footer-logo" />
            </div>
          </div>

          <div className="brand-col links">
            <p className="brand-desc">We manufacture premium Instrumentation Valves & Fittings — Manufacturer of Instrumentation Fittings, Valves, Manifolds, DBB Valves, PRV Valves, Injection Quills, Sealant Injection Grease Fittings.</p>
          </div>

          <div className="brand-col contact">
            <h4 className="brand-heading">Office / Warehouse</h4>
            <address className="brand-contact"><i className="fas fa-map-marker-alt" aria-hidden="true"></i> HP Flow Solutions Australia
              Unit 3, 5 Murphy Street O'Connor,
              Perth Western Australia 6163, Australia</address>
            <div className="brand-contact-row"><i className="fas fa-envelope" aria-hidden="true"></i> <a href="mailto:sales@hpfs.com.au">sales@hpfs.com.au</a></div>
            <div className="brand-contact-row"><i className="fas fa-phone" aria-hidden="true"></i> +61 439602113</div>
            <div className="brand-social align-items-center"> Connect with us
              <a href="#" aria-label="phone" className="social"> 
                <i className="fab fa-linkedin brand-color-blue" aria-hidden="true"></i></a>
                <a href="#" aria-label="phone" className="social"><i className="fab fa-facebook-f brand-color-blue" aria-hidden="true"></i></a>
                <a href="#" aria-label="phone" className="social"><i className="fab fa-twitter brand-color-blue" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
      </div>

      <div className="brand-footer-bottom">
        <div className="container">
          <small>© {new Date().getFullYear()} HP Flow Solutions Australia— All Rights Reserved</small>
        </div>
      </div>
    </footer>
  );
}
